import * as React from 'react';

import WizardIntroSvg from '../../assets/wizard-intro.svg';

import styles from './onboarding-graphic-wizard-intro.module.css';

export class OnboardingGraphicWizardIntro extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.intro}>
                <WizardIntroSvg />
            </div>
        );
    }
}
